import React from "react";
import { AlertTriangle, Home, LogOut } from "lucide-react";
import { Button, ButtonVariant } from "@/shared/ui/Button";
import { useAuth } from "@/shared/providers/AuthProvider";

interface AccessDeniedStateProps {
  message?: string;
  showHomeLink?: boolean;
  showLogoutLink?: boolean;
}

export const AccessDeniedState: React.FC<AccessDeniedStateProps> = ({
  message = "You do not have permission to access this resource.",
  showHomeLink = true,
  showLogoutLink = true,
}) => {
  const { logout, user } = useAuth();

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] p-8 text-center">
      <AlertTriangle className="h-16 w-16 text-destructive mb-4" />
      <h2 className="text-2xl font-bold mb-2">Access Denied</h2>
      <p className="text-text-muted mb-6 max-w-md">{message}</p>

      {/* {user && (
        <p className="text-sm text-text-muted mb-6">
          Signed in as: <span className="font-medium">{user.email}</span>
          <br />
          Roles: <span className="font-medium">{user.roles.join(", ")}</span>
        </p>
      )} */}

      <div className="flex gap-4">
        {showHomeLink && (
          <Button
            variant={ButtonVariant.Secondary}
            onClick={() => (window.location.href = "/dashboard")}
            data-testid="go-to-dashboard-button"
          >
            <Home className="h-4 w-4 mr-2" />
            Go to Dashboard
          </Button>
        )}

        {showLogoutLink && (
          <Button
            variant={ButtonVariant.Outline}
            onClick={logout}
            data-testid="sign-out-button"
          >
            <LogOut className="h-4 w-4 mr-2" />
            Sign Out
          </Button>
        )}
      </div>
    </div>
  );
};
